import { createEffect } from 'solid-js'
import type { Engine } from '../../lib/core/engine/Engine.type'
import type { Player } from '../../lib/core/player/Player.type'
import { PlayerKind } from '../../lib/core/player/PlayerKind.enum'
import { PlayerTurnStatus } from '../../lib/core/player/PlayerTurnStatus'
import { useAuthPlayerIdSignal } from '../signal/useAuthPlayerIdSignal'

const fn = (player: Player) => player.turn_status === PlayerTurnStatus.Pending && player.kind === PlayerKind.Human

export default function createSetEngineAuthPlayerIdFromLocalEffect(
  engine: Engine
) {
  const [, setAuthPlayerId] = useAuthPlayerIdSignal(engine)
  createEffect(() => {
    const player = engine.state.players.find(fn)
    if (player) {
      setAuthPlayerId(player.id)
    }
  })
}
